import React from 'react';
import { DetailsButton as StyledDetailsButton } from './DetailsButton.styled';

export interface DetailsButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
}

export function DetailsButton({ 
  children, 
  onClick, 
  className, 
  disabled 
}: DetailsButtonProps) {
  return (
    <StyledDetailsButton
      onClick={onClick}
      className={className}
      disabled={disabled}
    >
      {children}
    </StyledDetailsButton>
  );
}
